<template>
	<div id="solution-index">
		<header-section :subnav_show="false" :change_color="true"></header-section>
		<!-- ======= Hero Section ======= -->
		<div id="hero-solution" data-aos="zoom-out" data-aos-delay="100"></div>

		<div class="container" data-aos="fade-up">
			<div class="section-title">
				<h2>解决方案</h2>
				<p>SOLUTIONS</p>
			</div>
			<!-- list -->
			<el-row :gutter="15" class="el-row content" v-for="(v,k) in rePageList" :key="k">
				<a :href="'/solution/detail/'+v.id" target="_blank">
					<el-col :span="10" class="imgwrapper">
						<img v-if="v.image" :src="v.image" class="img-fluid" alt="标题图片">
						<img v-else src="/img/news/default.jpg" class="img-fluid" alt="标题图片">
					</el-col>
					<el-col :span="14">
						<h3><a :href="'/solution/detail/'+v.id" class="title-link" target="_blank">{{v.title}}</a></h3>
						<div class="article-summary" v-html="v.summary">
						</div>
						<div class="more">
							<a :href="'/solution/detail/'+v.id" target="_blank"><i
									class="bi bi-arrow-right-short"></i>查看详情</a>
						</div>
					</el-col>
				</a>
			</el-row>
			<!-- end list -->
		</div>
		<!-- footer -->
		<footer-section></footer-section>
	</div>
</template>
<script>
	import HeaderSection from "@/components/public/head.vue"
	import FooterSection from "@/components/public/footer.vue"

	export default {
		components: {
			HeaderSection,
			FooterSection
		},
		props: {},
		data() {
			return {
				queryParam: {
					channelId: 101,
					isShow: 1,
					page: 1,
					limit: 99
				},
				pagesize: 0,
				totalpages: 0,
				totalrecords: 0,
				rePageList: [],
			};
		},
		watch: {},
		computed: {},
		methods: {
			getArticlePageList() {
				this.$get(this.$api.getArticlePageList, this.queryParam).then(response => {
					if (response.code === 0) {
						this.rePageList = response.data.list;
						this.pagesize = response.data.pagesize;
						this.totalpages = response.data.totalpages;
						this.totalrecords = response.data.totalrecords;
						this.loading = false
					} else {
						window.console.log(response.msg);
					}
				});
			}
		},
		created() {
			this.getArticlePageList();
			//添加标题和meta标签
			document.title = '解决方案-河北科瑞达仪器科技股份有限公司'
			let arr = ['首页','产品中心','解决方案','客户案例','新闻动态','人才招聘','关于我们','联系我们']
			let m = document.querySelectorAll('meta');
			const meta = document.createElement('meta')
			meta.name = 'keywords'
			for(let i=0;i<m.length;i++){
				arr.some(item => {
					if(item == m[i].content){
						m[i].remove()
					}
				})
			}
			meta.content = '解决方案'
			
			m[0].after(meta)
			for(let i=0;i<m.length;i++){
				if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
					m[i].remove()
				}
			}
		},
	};
</script>
<style scoped>
	/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
	#solution-index {
		overflow-x: hidden;
	}

	#hero-solution {
		width: 100%;
		height: 45vh;
		background: url("~@/static/img/banner/solution-banner.jpg");
		background-size: cover;
		position: relative;
	}

	.img-fluid {
		overflow: hidden;
		border-radius: 10px;
		width: 480px;
	}

	.title-link {
		height: 26px;
		line-height: 26px;
		overflow: hidden;
		font-size: 16px;
		font-weight: 700;
		color: rgb(4, 31, 121);
		margin-top: 4px;
	}

	.title-link:hover {
		color: rgb(247, 41, 5);
	}

	.article-summary {
		display: block;
		min-height: 140px;
		max-height: 200px;
		line-height: 30px;
		margin-top: 25px;
	}

	.content {
		box-sizing: content-box;
		padding: 30px 20px;
		margin: 30px 15px;
		min-height: 200px;
		box-shadow: 0px 0px 20px 0px rgba(11, 35, 65, 0.1);
		position: relative;
		background: #fff;
		font-size: 14px;
		border-radius: 12px;
	}

	.content>a {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
	}

	.content h3 {
		font-weight: 600;
		font-size: 18px;
	}

	.content ul {
		list-style: none;
		padding: 0;
	}

	.content ul li {
		padding-bottom: 10px;
	}

	.content ul i {
		font-size: 16px;
		padding-right: 4px;
		color: #3b4ef8;
	}

	.content p:last-child {
		margin-bottom: 0;
	}

	.content:hover {
		transform: translateY(-10px);
		transition: 0.2s
	}

	.content:hover .title-link {
		color: rgb(247, 41, 5);
	}

	.content .imgwrapper {
		width: 480px;
		height: 240px;
		padding-left: 0;
		padding-right: 0;
		margin-right: 10px;
		overflow: hidden;
		border-radius: 10px;
	}

	.content:hover .imgwrapper img {
		border-radius: 10px;
		max-width: 480px;
		height: auto;
		transform: scale(1.1);
		transition: 0.8s;
	}

	.more a:hover {
		background: blue;
	}

	.more a {
		background: #2828f2;
		color: #fff
	}
</style>